<template>
    <div class="text-center loader d-flex justify-center" :class="(fullScreen) ? 'full-screen' : 'inside-parent'" v-if="showLoader">
        <div class="spinner-border" :class="previewLoader ? 'preview-loader' : ''" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'loader',
        props: {
            showLoader: {
                required: true
            },
            size: {
                default() {
                    return 50;
                }
            },

            fullScreen: {
                default: () => false,
            },

            previewLoader: {
              required: false,
              default: false,
            }
        }
    }
</script>

<style scoped>
    .spinner-grow {
        width: 5rem;
        height: 5rem;
    }

    .full-screen {
        position: fixed;
    }

    .inside-parent {
        position: absolute;
    }

    .loader {
        display: block;
        width: 100%;
    }

    .loader div {
        color: #c61e56;
    }

    .preview-loader {
      margin-left: 65%;
      margin-top: 10%;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Loader.vue